import type { Error as Auth0Error } from "@auth0/auth0-acul-js";

import { butterfieldLogo } from "@/assets/logos";
import { useResetPasswordSuccessManager } from "../hooks/useResetPasswordSuccessManager";
import {
  buildFallbackLoginLink,
  rebaseLinkToCurrentOrigin,
} from "../utils/helpers/urlUtils";

// const heroImageUrl =
//   "https://media.butterfield.com/page-image_imageUrl_a470c5db-2106-4964-a8f2-414c0415efe6_1744290400564.jpg";
const heroImageUrl =
  "https://cdn.mediavalet.com/cato/butterfield/aEeF6_P6lk6o6VqdMg_3cQ/GX_bog2pTkawcjy_quukQA/Large/DSC09355-slovenia-ivan-sardi-2026.jpeg?f=auto";

function ResetPasswordSuccessScreen() {
  const { errors, texts, loginLink, transactionState } =
    useResetPasswordSuccessManager();

  const sdkErrors = (errors || []) as Auth0Error[];
  const generalErrors = sdkErrors.filter((error) => !error.field);
  const localizedLoginLink = loginLink && rebaseLinkToCurrentOrigin(loginLink);
  const fallbackLoginLink = buildFallbackLoginLink(transactionState);
  const resolvedLoginLink = localizedLoginLink || fallbackLoginLink;

  const headingText = texts?.title || "Password updated";
  const descriptionText =
    texts?.description ||
    "Your password has been reset successfully. You can now sign in.";
  const buttonText = texts?.buttonText || "Back to sign in";

  return (
    <div className="overflow-hidden rounded-none bg-white shadow-[0_30px_80px_rgba(2,6,23,0.35)] min-h-screen">
      <div className="grid min-h-screen grid-cols-1 md:grid-cols-2">
        <div className="relative order-1 h-56 sm:h-72 md:order-2 md:block md:h-full">
          <img
            src={heroImageUrl}
            alt="Auth0 experience preview"
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-slate-900/10 via-transparent to-slate-900/30" />
        </div>

        <div className="flex h-full flex-col justify-center gap-6 order-2 bg-white px-10 py-12 md:order-1 md:px-12">
          <div className="mb-0 flex flex-col items-start text-left">
            <img
              src={butterfieldLogo}
              alt="Butterfield logo"
              className="h-14 w-auto"
              loading="lazy"
            />
            <p className="mt-4 font-display text-xl font-normal text-ink">{headingText}</p>
            <p className="mt-2 text-sm text-ink-2">{descriptionText}</p>
          </div>

          {generalErrors.length > 0 && (
            <div className="rounded-none border border-danger/30 bg-danger-bg px-4 py-3 text-sm text-danger">
              <ul className="list-disc space-y-1 pl-5">
                {generalErrors.map((error, index) => (
                  <li key={`resetpasswordsuccess-general-error-${index}`}>
                    {error.message}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {resolvedLoginLink ? (
            <a
              href={resolvedLoginLink}
              className="inline-flex w-full items-center justify-center rounded-sm border border-accent bg-accent px-4 py-3 text-base font-semibold uppercase tracking-[0.1em] text-on-accent transition hover:cursor-pointer hover:border-accent-hover hover:bg-accent-hover hover:shadow-sm"
            >
              {buttonText}
            </a>
          ) : (
            <p className="text-center text-sm font-semibold text-ink-2">{buttonText}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordSuccessScreen;
